import "./ConsoleFooter.styles.scss";
const ConsoleFooter = () => {
  return (
    <ul className="consolefooter">
      <li>&copy; Tesseract Imaging</li>
      <li style={{ color: "#4096EF" }}>Privacy Policy</li>
      <li style={{ color: "#4096EF" }}>Terms and Condition</li>
    </ul>
  );
};

export default ConsoleFooter;
